import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import TextInput from '../Common/TextInput';
import Notification from '../Common/Notification';
import { useConfig } from '../../DataStore/ConfigContext';
import ajaxConfig from '../../util/remote/ajaxConfig';

const CompanyTypeSelectionModal = ({ onClose }) => {
  const [companyType, setCompanyType] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {getCompanyTypes, companyTypes, getCompanyProfile, company} = useConfig();

  useEffect(() => {
    getCompanyTypes();
    }, []);


    if (!company) {
        return;
    }

  if (company.company_code) {
        return;
  }

  const handleSetType = async () => {
    if (!companyType) {
      setNotify(<Notification type='danger' message='Please select your company type' />);
      return;
    }

    setLoading(true);
    const response = await ajaxConfig.configureCompanyType(companyType.value,);
    setLoading(false);

    if (response.status === 'OK') {
      setNotify(<Notification type='success' message={response.message} />);
      getCompanyProfile();
      setTimeout(() => closeModal(), 1000);
    } else {
      setNotify(<Notification type='danger' message={response.message} />);
    }
  };

  const closeModal = () => {
    setNotify(null);
    onClose();
  };

  const RenderCompanyType = () => {
    const options = [];
    Array.isArray(companyTypes) &&
    companyTypes.map((item) =>
        options.push({ label: item.company_type, value: item.id })
      );

    return (
      <TextInput
        label="Company Type"
        type="select"
        leftIcon="fa fa-building"
        placeholder={companyType.label || "Select your company type...."}
        options={options}
        onChange={(item) => setCompanyType(item)}
        leftComponent={
          <i className="fa fa-building link" onClick={getCompanyTypes}></i>
        }
        loading={!companyTypes}
        wrap
      />
    );
  };

  return (
    <BsModal
      show={true}
      onClose={closeModal}
      title="Select Company Type"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !companyType}
            onClick={handleSetType}
          >
            <i className="fa fa-check-circle mr-1"></i> Save
          </button>
        </>
      }
    >
      <div className="alert alert-info">
        <strong>What is a Company Type?</strong> <br/>
        Your company type refers to the nature of your business operations (e.g., Gym, Manufacturing, School, NGO, etc). This helps us customize your dashboard and features to best suit your workflow.
      </div>

      {RenderCompanyType()}
      {loading && <div className="mt-3"><i className="fa fa-spinner fa-spin"></i> Saving...</div>}
      {notify}
    </BsModal>
  );
};

export default CompanyTypeSelectionModal;
